var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"rgba(255, 255, 255, 1)","flat":""}},[_c('v-row',{attrs:{"no-gutters":"","align":"center"}},[(!_vm.showDrawer)?_c('app-logo'):_vm._e(),_c('v-spacer'),_c('auth-control'),_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.showDrawer = !_vm.showDrawer}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }